/**
 * @license @tabler/icons-react v3.10.0 - MIT
 *
 * This source code is licensed under the MIT license.
 * See the LICENSE file in the root directory of this source tree.
 */

import createReactComponent from '../createReactComponent.mjs';

var IconCurrencyDram = createReactComponent("outline", "currency-dram", "IconCurrencyDram", [["path", { "d": "M4 10a6 6 0 1 1 12 0v10", "key": "svg-0" }], ["path", { "d": "M12 16h8", "key": "svg-1" }], ["path", { "d": "M12 12h8", "key": "svg-2" }]]);

export { IconCurrencyDram as default };
//# sourceMappingURL=IconCurrencyDram.mjs.map
